import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import RenderPhoneInput from 'react-phone-input-2';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputPhoneForm from './InputPhoneForm';
import CodeVerify from './CodeVerify';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import SmartPhoneIcon from '@material-ui/icons/Smartphone';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import axios from 'axios';


const styles = theme => ({
    root: {
        // marginLeft: theme.spacing.unit * 3,
        // width: 400,
        // height: 300,
        // float:'left',
        display: 'block',
        justifyContent: 'center',
        // marginLeft: '100px',
        // padding:'30px'
    },
    card: {
        width: '100%',
        height: '100%',
    },
    button:{
        width: '250px',
        margin: '0px'
    },
    loading:{
        //display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    bInput: {
      background: "rgba(255, 255, 255, 0.5)",
      outline: "0",
      color: "#99192D",
      wordWrap: "break-word",
      wordBreak: "break-word",
      border: "2px solid #99192D",
      textTransform: 'none',
      paddingTop: "15px",
      paddingBottom: "15px",
      borderRadius: "25px",
    //   height: "30px",
      marginLeft: "3px",
      marginRight: "3px",
      boxSizing: "border-box",
      fontSize: "16px",
      "&:hover": {
        color: "white",
      },
    },
});

class Verification extends Component {

    componentDidMount(){

        console.log((''+this.props.email).endsWith('@primecredit.com'))
        console.log('**Verification email: '+this.props.email)
        if((''+this.props.email).endsWith('@primecredit.com')){
            // setTimeout(() => {
                this.props.handleComplete()
            // }, 2000);
        }

        let search = ''+window.location.href

        if (this.props.isVerified && this.props.isSignatureVerifyNeeded == undefined){
            this.props.handleComplete()
        }

        console.log('---Verification search: '+search)
        if(search){
            var ist = search.includes('/?isload=true')
            //console.log('Verification search load: '+load)
            if (ist){

            }else{
            //   window.location.redi(search+'/?isload=true')
                window.location.replace(search+'/?isload=true')
            }
        }
       
    }

    render() {
        const { classes } = this.props;
        console.log('verification: '+this.props.isVerified);
        console.log('&&verification: telephone'+this.props.telephone);
        if(this.props.isVerified && this.props.isSignatureVerifyNeeded == undefined){
            console.log('verification in true ');
            return (
                <div>
                    <CardContent>
                        <Typography variant='title' component='p'>
                            {this.props.telephone} {this.context.t("Verify")}{this.context.t("Done")} 
                            <Button className={classes.bInput} 
                                onClick={()=>{this.props.handleComplete()}}>{this.context.t("Next")}
                            </Button>
                        </Typography>
                    </CardContent>
                </div>
            )
        }
        else{
            return (
            <div className={classes.root}>
                <InputPhoneForm handleComplete={this.props.handleComplete} isSignatureVerifyNeeded={this.props.isSignatureVerifyNeeded} email={this.props.email}/>
            </div>);
        }
    }
}

const mapStateToProps = (state) => {
    let uniqueId = localStorage.getItem('token');
    let typeOfAccount = localStorage.getItem('typeOfAccount');
    let userType = '';
        if(state.caseInfo.caseData.claimantUniqueId == uniqueId){
            userType = 'claimant';
        }else if(state.caseInfo.caseData.respondentUniqueId == uniqueId){
            userType = 'respondent';
        }
        else if (typeOfAccount == 'admin'){
            userType = 'admin'
        }
        else{
            userType = "claimant";
        }
    console.log('verification userType: '+userType)
    console.log('state.caseInfo.caseData.lender_email_address: ',state.caseInfo.caseData.lender_email_address)
    console.log('state.caseInfo.caseData.lender_email_address',state.caseInfo)
    console.log('verification verification state.caseInfo.caseData.agreement_type : '+state.caseInfo.caseData.agreement_type == 'EstateAgentDispute')
    if (state.caseInfo.caseData.agreement_type == 'EstateAgentDispute'){
        console.log('@verification state.caseInfo.caseData.a2@: '+state.caseInfo.caseData.a2 == 'vendor')
        if (state.caseInfo.caseData.a1  == 'seperate'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.namesOfA2[0].a11b,
                email: state.caseInfo.caseData.namesOfA2[0].a11a,
                caseData: state.caseInfo.caseData,
                userType: userType,
            }
        }
        else if ((state.caseInfo.caseData.a2  == 'purchaser' || state.caseInfo.caseData.a2  == 'vendor') && state.caseInfo.caseData.a1  !== undefined){
            if (userType == 'claimant'){
                if (state.caseInfo.caseData.a2  == 'vendor'){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        // telephone: state.caseInfo.caseData.namesOfA2[0].a11b,
                        telephone: state.caseInfo.caseData.a3c,
                        email: state.caseInfo.caseData.a3b,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                    }
                }
                
                
            }
            else if (userType == 'respondent'){
                if (state.caseInfo.caseData.a2  == 'vendor'){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfVendors[0].a11b,
                        email: state.caseInfo.caseData.namesOfVendors[0].a11a,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                    }
                } 
                else{
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfPurchasers[0].a12j,
                        email: state.caseInfo.caseData.namesOfPurchasers[0].a12i,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                    }
                }
            }
        }
        else{
            if (userType == 'claimant'){
                console.log('verification state.caseInfo.caseData.a3c: '+state.caseInfo.caseData.a3c)
                if (state.caseInfo.caseData.a3c !== undefined){
                    
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.a3c,
                        email: state.caseInfo.caseData.a3b,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                    }
                }
            }
            else if (userType == 'respondent'){
    
                if (state.caseInfo.caseData.namesOfVendors !== undefined){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfVendors[0].a11b,
                        email: state.caseInfo.caseData.namesOfVendors[0].a11a,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                    }
                    
                }
                else if (state.caseInfo.caseData.namesOfPurchasers !== undefined){
                    
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfPurchasers[0].a12j,
                        email: state.caseInfo.caseData.namesOfPurchasers[0].a12i,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                    }
                    
                }
                else if (state.caseInfo.caseData.namesOfA2 !== undefined){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfA2[0].a11b,
                        email: state.caseInfo.caseData.namesOfA2[0].a11a,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                    }
                    
                }
            }
        }
        
    }
    else if (state.caseInfo.caseData.agreement_type == 'MoneyLent'){
        
        return {
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
            telephone: state.caseInfo[`${state.caseInfo.userType}_telephone`],
            email: `${state.caseInfo.userType == 'claimant' ? state.caseInfo.caseData.lender_email_address : state.caseInfo.caseData.borrower_email_address}`,
            caseData: state.caseInfo.caseData,
            userType: userType,
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'creditcard'){
        
        return {
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
            telephone: `${state.caseInfo.userType == 'claimant' ? state.caseInfo.caseData.a8c : state.caseInfo.caseData.a16b}`,
            email: `${state.caseInfo.userType == 'claimant' ? state.caseInfo.caseData.a8b : state.caseInfo.caseData.a16a}`,
            caseData: state.caseInfo.caseData,
            userType: userType,
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'other_dispute'){
        if (userType == 'claimant'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.a8c,
                email: state.caseInfo.caseData.a8b,
                caseData: state.caseInfo.caseData,
                userType: userType,
            }
        }
        else if (userType == 'respondent'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.a16b,
                email: state.caseInfo.caseData.a16a,
                caseData: state.caseInfo.caseData,
                userType: userType,
            }
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'SalesOfGoods' ||
             state.caseInfo.caseData.agreement_type == 'serviceDispute' || 
             state.caseInfo.caseData.agreement_type == 'insuranceDispute'){
        if (userType == 'claimant'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.a8c,
                email: state.caseInfo.caseData.a8b,
                caseData: state.caseInfo.caseData,
                userType: userType,
            }
        }
        else if (userType == 'respondent'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.a16b,
                email: state.caseInfo.caseData.a16a,
                caseData: state.caseInfo.caseData,
                userType: userType,
            }
        }
    }

    
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

Verification.contextTypes = {
    t: PropTypes.func
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Verification));